import { useRepositoryMutation } from '@mews-commander/data-access';
import { lt, showSuccessAlert, SubmitHandler } from '@mews/framework';
import { useOwnerIdQueryPayload } from '../../queries/useOwnerId';
import { formValues } from './useMfaSetupForm';

export const useSaveMfaSetup = ({ onSuccess }: { onSuccess?: () => void }) => {
    const ownerIdPayload = useOwnerIdQueryPayload();
    const { mutateAsync, isPending } = useRepositoryMutation('mfaConfiguration', 'update', {
        invalidateQueries: { mfaConfiguration: ['get'] },
        onSuccess: () => {
            showSuccessAlert({ description: lt('SaveSuccessMessage') });
        },
    });

    const handleSave: SubmitHandler<formValues> = async (data: formValues, { dirtyFields }) => {
        await mutateAsync(
            {
                ...(dirtyFields.enforceAuthenticatorSetup
                    ? { enforceAuthenticatorSetup: { value: data.enforceAuthenticatorSetup } }
                    : {}),
                ...(dirtyFields.exemptedEnterpriseProfileIds && data.enforceAuthenticatorSetup
                    ? { exemptedEnterpriseProfileIds: data.exemptedEnterpriseProfileIds }
                    : {}),
                ...ownerIdPayload,
            },
            {
                onSuccess: () => {
                    onSuccess?.();
                },
            }
        );
    };

    return {
        onSave: handleSave,
        isSaving: isPending,
    };
};
